document.addEventListener("DOMContentLoaded",function(){document.querySelectorAll(".ProductForm").forEach(form=>{form.addEventListener("submit",function(e){e.preventDefault();const formData=new FormData(this),submitButton=this.querySelector(".quick-add-cart");submitButton&&(submitButton.disabled=!0),fetch("/cart/add.js",{method:"POST",body:formData}).then(()=>{const cartTrigger=document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');cartTrigger&&cartTrigger.click(),fetch("/cart.js").then(res=>res.json()).then(cart=>{const countElement=document.querySelector("[data-cart-count]");countElement&&(countElement.textContent=cart.item_count),fetch(window.location.href).then(res=>res.text()).then(html=>{const tempDiv=document.createElement("div");tempDiv.innerHTML=html;const newDrawer=tempDiv.querySelector("#sidebar-cart"),currentDrawer=document.querySelector("#sidebar-cart");newDrawer&&currentDrawer&&(currentDrawer.innerHTML=newDrawer.innerHTML)})}),submitButton&&(submitButton.disabled=!1)}).catch(err=>{console.error("Add to cart failed:",err),submitButton&&(submitButton.disabled=!1)})})})}),document.addEventListener("DOMContentLoaded",function(){const slider=document.querySelector(".feature-banner__list");let isDown=!1,startX,scrollLeft;slider.addEventListener("mousedown",e=>{isDown=!0,slider.classList.add("is-dragging"),startX=e.pageX-slider.offsetLeft,scrollLeft=slider.scrollLeft}),slider.addEventListener("mouseleave",()=>{isDown=!1,slider.classList.remove("is-dragging")}),slider.addEventListener("mouseup",()=>{isDown=!1,slider.classList.remove("is-dragging")}),slider.addEventListener("mousemove",e=>{if(!isDown)return;e.preventDefault();const walk=(e.pageX-slider.offsetLeft-startX)*1.5;slider.scrollLeft=scrollLeft-walk})}),document.addEventListener("DOMContentLoaded",function(){const list=document.querySelector(".feature-banner__list"),dotsContainer=document.querySelector(".feature-banner__dots");function updateDots(){if(!list||!dotsContainer)return;const containerWidth=list.offsetWidth,scrollWidth=list.scrollWidth;let totalPages=Math.ceil((scrollWidth-containerWidth)/containerWidth)+1;totalPages=Math.max(Math.min(totalPages,3),1),dotsContainer.innerHTML="";for(let i=0;i<totalPages;i++){const dot=document.createElement("div");dot.classList.add("feature-banner__dot"),i===0&&dot.classList.add("active"),dotsContainer.appendChild(dot)}const dots=dotsContainer.querySelectorAll(".feature-banner__dot");list.addEventListener("scroll",()=>{const scrollLeft=list.scrollLeft,pageIndex=Math.round(scrollLeft/containerWidth);dots.forEach(dot=>dot.classList.remove("active")),dots[pageIndex]&&dots[pageIndex].classList.add("active")})}updateDots(),window.addEventListener("resize",updateDots),setTimeout(()=>{list&&(list.scrollLeft=0)},100)});
//# sourceMappingURL=/s/files/1/0310/4338/7523/t/36/assets/custom.js.map?v=1747246857


// Make entire carousel card clickable
document.addEventListener('click', function(e) {
  const card = e.target.closest('.jdgm-carousel-item');
  
  if (card) {
    const productTitle = card.querySelector('.jdgm-carousel-item__product-title');
    
    if (productTitle) {
      const title = productTitle.textContent.trim();
      
      // Manual product mapping
      const productMap = {
        'Flyweight Shirt': '/products/flyweight-shirt-copy',
        'Cooling Polo Shirt': '/products/short-sleeve-polo-shirt',
        'Dead Drop Jacket': '/products/dead-drop-jacket',
        'Dry Duffle Bag': '/products/dry-duffle-bag',
        'Carrizo Pants': '/products/carrizo-pants',
        'Conejos River Hoodie': '/products/conejos-river-hoodie',
        'Corcho Hat': '/products/corcho-hat',
        'Zavala Flag Hat': '/products/zavala-flag-hat',
        'Polo Shirt': '/products/short-sleeve-polo-shirt'
      };
      
      const url = productMap[title];
      if (url) {
        window.location.href = url;
      }
    }
  }
}, true);

// Add SVG verified badge to carousel reviews
function addCarouselSVGBadges() {
  var carouselReviews = document.querySelectorAll('.jdgm-carousel-item__reviewer-wrapper');
  carouselReviews.forEach(function(wrapper) {
    var buyerBadge = wrapper.querySelector('.jdgm-rev__buyer-badge');
    if (buyerBadge && !wrapper.querySelector('.jdgm-rev__source')) {
      var svgBadge = document.createElement('span');
      svgBadge.className = 'jdgm-rev__source';
      svgBadge.setAttribute('data-source', 'shop-app');
      var img = document.createElement('img');
      img.className = 'jdgm-rev__verification-badge-img';
      img.alt = 'Verified by Shop';
      img.src = 'https://judgeme-public-images.imgix.net/judgeme/verified-badge-v2/verified-by-shop_light.svg';
      svgBadge.appendChild(img);
      var authorName = wrapper.querySelector('.jdgm-carousel-item__reviewer-name');
      if (authorName) {
        authorName.insertAdjacentElement('afterend', svgBadge);
      }
    }
  });
}

setTimeout(addCarouselSVGBadges, 2000);
setTimeout(addCarouselSVGBadges, 3000);

// Add verification badges under stars
(function() {
  function addVerifiedBadges() {
    var reviews = document.querySelectorAll('.jdgm-rev[data-verified-buyer="true"]');
    reviews.forEach(function(review) {
      if (review.querySelector('.custom-verified-review-badge')) return;

      var ratingRow = review.querySelector('.jdgm-row-rating');
      if (!ratingRow) return;

      var shopSource = review.querySelector('.jdgm-rev__source[data-source="shop-app"]');
      var storeInvitation = review.querySelector('.jdgm-rev__transparency-badge[data-badge-type="review_collected_via_store_invitation"]');

      var badge = document.createElement('div');
      badge.className = 'custom-verified-review-badge';
      badge.style.cssText = 'display: flex; align-items: center; gap: 3px; margin-top: 4px; margin-bottom: 4px;';

      if (storeInvitation) {
        // Klaviyo email review — green checkmark
        badge.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="vertical-align: middle; margin-right: 3px;"><circle cx="12" cy="12" r="12" fill="#44634F"/><path d="M7 12.5l3 3 7-7" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="font-size: 12px; color: #44634F; font-weight: 600;">Verified Review</span>';
        ratingRow.appendChild(badge);
      } else if (shopSource) {
        // Shop review — move the original purple badge under the stars
        shopSource.style.display = 'flex';
        shopSource.style.marginTop = '4px';
        shopSource.style.marginBottom = '4px';
        ratingRow.appendChild(shopSource);
        // Mark as done so we don't process again
        var marker = document.createElement('span');
        marker.className = 'custom-verified-review-badge';
        marker.style.display = 'none';
        review.appendChild(marker);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addVerifiedBadges);
  } else {
    addVerifiedBadges();
  }

  var observer = new MutationObserver(function() {
    addVerifiedBadges();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();